import React, { useState, useEffect, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './../../wrapper';
import { logInUserInfo } from '../../Actions/Users';
import { checkPrivileges, showDates } from '../../Helpers';
import withRoutes from '../../HOC/HocRoutes';

import SaleOrder from './SaleOrder';
import IndividualInvoice from './Individual';

import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import MainProcessInvoices from './ProcessInvoices';
import PoInvoicesDn from './PoInvoiceDn';
import useDownloadFile from '../../Hooks/useDownloadFile';

const defaultPages = ['account', 'device', 'group'];
         const CheckedRoute = ({ checked, children, redirectTo = "/" }) => {
        return checked ? children : <Navigate to={redirectTo} replace />;
    };
const ProcessInvoices = (props) => {
    const dispatch = useDispatch();
  const { downloadInvoice, loader:apiLoader } = useDownloadFile(dispatch)

    const logInUser = useSelector((state) => state.logInUsers);
    const themecolors = useSelector((state) => state.themecolors);
    const [sessionCallTrack, setSessionCallTrack] = useState(true);
     const poRequestChildRef = useRef();
     const poInvoiceDnsRef=useRef()

  const handleSidebarSearch = ({to,from,account,vehicle,status}) => {
    if (poRequestChildRef.current) {
      poRequestChildRef.current.getPoRequests({ to, from, account, vehicle,status });
    }

    if(poInvoiceDnsRef.current){
        poInvoiceDnsRef.current.getPoInvoicesDns({to,from,account,vehicle})
    }
  };
  const handleHeaderSearch=({poNumber,poRefNumber})=>{
    if(poRequestChildRef.current){
        poRequestChildRef.current.getPoRequests({poNumber,poRefNumber});
    }
  }
  const handleDownload = (data, type) => {
    let updatedData={
        ...data,
        account:data.contractNumber
    }

  downloadInvoice(updatedData,type);
};
    const location=useLocation()

      let currentPath = location.pathname.replace("/process-invoices", "");
  if (currentPath.startsWith("/")) currentPath = currentPath.slice(1);
  if (currentPath === "" || currentPath === "/") currentPath = "";



    const controleSession = () => {
        if (localStorage.getItem('userInfo')) {
            fetch('/api/session', { method: 'DELETE' })
                .then(res => res.json())
                .then(response => {
                    if (response.ok) props.navigate('/logout');
                    else throw response;
                })
                .catch(() => {});
        }
    };

    // Fetch session info on mount
    useEffect(() => {
        if (!logInUser && sessionCallTrack) {
            setSessionCallTrack(false);
            fetch('/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05', {
                headers: { Accept: 'application/json; odata=verbose' },
                params: { app: '3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05' },
            })
                .then(res => {
                    if (res.ok) {
                        res.json().then(res => {
                            if (res.status === 'success') {
                                const userInfo = res.data;
                                props.setActiveLanguage(userInfo?.attributes?.lang || 'en');
                                dispatch(logInUserInfo(userInfo));
                            } else if (res?.statusCode === '440') {
                                window.location.replace('/login');
                            } else if (res.statusCode) {
                                const err = res?.message.split(':');
                                err[1] = err[1].replace(')', '');
                                toast.error(props.translate(err[1]));
                                props.navigate('/login');
                            }
                        });
                    } else {
                        props.navigate('/login');
                        throw res;
                    }
                })
                .catch(() => toast.error('somethingWentWrong'));
        }
    }, [logInUser, sessionCallTrack, dispatch, props]);

    if (!logInUser) return null;

    if (checkPrivileges('porequest')) {
        return (
            <Routes>
                <Route
                    path="/"
                    element={
                        <Layout {...props} themecolors={themecolors} noSidebar="" selecteFilters={handleSidebarSearch} key={currentPath} currentPath={currentPath} downloadInvoices={handleDownload}>
                            <MainProcessInvoices
                                handleHeaderSearch={handleHeaderSearch}
                                translate={props.translate} />
                        </Layout>
                    }
                >
                    <Route index element={
                        <CheckedRoute checked={checkPrivileges("porequest")} redirectTo="/users">
                            <SaleOrder {...props} ref={poRequestChildRef} />
                        </CheckedRoute>
                    } />
                    <Route path="individual" element={
                        <CheckedRoute checked={checkPrivileges("porequest")} redirectTo="/users">
                            <IndividualInvoice {...props} ref={poRequestChildRef} />
                        </CheckedRoute>
                    } />
                    <Route path="view" element=
                        {<CheckedRoute checked={checkPrivileges("porequestCreate")} redirectTo="/users">
                            <PoInvoicesDn {...props} ref={poInvoiceDnsRef}/>
                        </CheckedRoute>} />
                </Route>
            </Routes>
        );
    }
    else if (checkPrivileges('account') && !checkPrivileges('device') && !checkPrivileges('group')) {
        controleSession();
        return null;
    } else {
        defaultPages.forEach(page => {
            if (checkPrivileges(page)) props.navigate(page === 'device' ? '/units' : `/${page}s`);
        });
        return null;
    }
};

export default connect()(withRoutes(ProcessInvoices));
